import { DEFAULT_BASE_RES } from '@smarsh-cyber/shared/models';
import {
  LoginModel,
  ResetPasswordModel,
  VerifyOtpModel,
  VerifyUserModel
} from '../models/ui_models';
import {
  GetLoginOTPModel,
  VerifyLoginOTPModel
} from '../models/ui_models/passcode/otp-login';

export interface AuthState {
  login: LoginModel;
  verifyUser: VerifyUserModel;
  verifyOtp: VerifyOtpModel;
  resetPassword: ResetPasswordModel;
  getLoginOtp: GetLoginOTPModel;
  verifyLoginOtp: VerifyLoginOTPModel;
}

export const initialAuthState: AuthState = {
  login: DEFAULT_BASE_RES,
  verifyUser: DEFAULT_BASE_RES,
  verifyOtp: DEFAULT_BASE_RES,
  resetPassword: DEFAULT_BASE_RES,
  getLoginOtp: DEFAULT_BASE_RES,
  verifyLoginOtp: DEFAULT_BASE_RES
};
